<div cdkTrapFocus class="creation-modal-wrapper">
  <div>
    <button id="close-modal-cross-btn" type="button" class="close pull-right btn-close-modal" aria-label="Close"
            (click)="cancelModal()"
            (keydown.enter)="cancelModal()">
      <span id="close-modal-x" class="close-modal-x" aria-hidden ="true">&times;</span>
    </button>
  </div>
  <div class="modal-header">
    <label i18n="Select from available areas of focus Title|Title of select areas of focus@@selectAreasTitle" class="modal-header-title">Select from available areas of focus</label>
    <label i18n="Available areas of focus|Available areas of focus@@availableRolesAndAreas" class="modal-header-subtitle">Available choices</label>
  </div>
  <div class="modal-body">
    <ul id="aofSelectionList" role="listbox" class="col-md-8" #aofSelectionList>
      <li tabindex="0" role="option" aria-checked="false">
        <input type="checkbox" tabindex="-1" [checked]="allChecked" class="aof text-area" rows="6"
               name="accountCreationAoFTextArea" id="aof-select-all" (change)="toggleSelectAllAoFOnPage()">
        <span i18n="Select all areas Option|Option to select all areas@@selectAllRolesAndAreasOption" class="form-check-label"
               for="aof-select-all"> Select all</span>
      </li>
      <li class="form-check" tabindex="-1" role="option" *ngFor="let area of fixedAreasOfFocus; let i = index">
        <input class="form-check-input" tabindex="-1" rows= "0" [checked]="area.checked" (change)="onChange(area, $event.target)" name="{{'area' + i}}" type="checkbox" id="{{'area' + i}}" #aofCheckbox >
        <span for="{{'area' + i}}" class="form-check-label">
          {{area.aof}}
        </span>
      </li>
    </ul>
  </div>
  <div class="modal-buttons">
  <button i18n="Cancel button Title|Title for Cancel button@@cancelButton" class="modal-button cancel" id="cancel"
          (click)="cancelModal()" type="button">Cancel
  </button>
  <button i18n="Done button Title|Title for Done button@@doneButton" class="modal-button done" id="done"
          (click)="doneModal()" type="button">Done
  </button>
  </div>
</div>
